// Shared reveal transition for corner-pinned "card" layers (TextCard,
// VideoCard): fades opacity in/out AND, in step, blurs out toward the
// hidden end — sharp when fully shown, a soft 3x3-tap blur when fully
// hidden, matching the reference's installFade/FADE_MAP exactly. Patched
// into the material via onBeforeCompile rather than a bespoke
// ShaderMaterial, so the card keeps MeshBasicMaterial's own map/color/
// transparent handling and only the sampling step changes.
import * as THREE from "three";

const FADE_PARS = "uniform float uFade;\nuniform float uBlur;\n";

const FADE_MAP = `
#ifdef USE_MAP
  vec4 acc = vec4(0.0);
  float wsum = 0.0;
  for (int y = -1; y <= 1; y++){
    for (int x = -1; x <= 1; x++){
      float w = (x == 0 && y == 0) ? 4.0 : ((x == 0 || y == 0) ? 2.0 : 1.0);
      acc += texture2D(map, vMapUv + vec2(float(x), float(y)) * uBlur) * w;
      wsum += w;
    }
  }
  diffuseColor *= acc / wsum;
#endif
  diffuseColor.a *= uFade;
`;

// blurAmt is the preset's authored max blur radius (UV units) — reached at
// vis === 0 and easing to 0 (fully sharp) as vis approaches 1, same curve
// as the reference (`uBlur = blurAmt * (1 - vis)`).
export function installCardFade(material, blurAmt) {
  const uniforms = {
    uFade: { value: 1 },
    uBlur: { value: 0 },
  };

  material.onBeforeCompile = (shader) => {
    shader.uniforms.uFade = uniforms.uFade;
    shader.uniforms.uBlur = uniforms.uBlur;
    shader.fragmentShader = FADE_PARS + shader.fragmentShader;
    shader.fragmentShader = shader.fragmentShader.replace(
      "#include <map_fragment>",
      FADE_MAP,
    );
  };
  material.needsUpdate = true;

  return {
    uniforms,
    // vis: 0 (hidden) .. 1 (shown). Called every tick from the card's own
    // update() as its gsap-driven visibility value changes.
    setVisibility(vis) {
      uniforms.uFade.value = vis;
      uniforms.uBlur.value = blurAmt * (1 - vis);
    },
  };
}
